import SimpleBar from 'simplebar';
import { gsap, Power4, Power3 } from 'gsap/all.js';
import DrawSVGPlugin from '../autoload/DrawSVGPlugin.js';
import ScrollTrigger from 'gsap/ScrollTrigger.js';
import ImagesLoaded from 'imagesloaded/imagesloaded.js';
export default {
  init() {
    // JavaScript to be fired on all pages
    
    // load video for mobile or desktop  
    //get all vids
var video =  document.querySelectorAll('.a-video')

//add source to video tag
function addSourceToVideo(element, src) {
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
//	console.log(src);
    element.appendChild(source);
	
}

//determine screen size and select mobile or desktop vid
function whichSizeVideo(element, src) {
	var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
	if (windowWidth > 1200 ) {
		addSourceToVideo( element, src.dataset.desktopVid);
	} else {
		addSourceToVideo(element, src.dataset.mobileVid);
	}
}

//init only if page has videos
function videoSize() {
	if (video !== undefined) {
	video.forEach(function(element) {
			whichSizeVideo(  
				element, //element
				element  //src locations
			);	
    
    // add preloader 
    $(element).on('loadstart', function () {
    $(this).parent().addClass('loading');
  });
  $(element).on('play', function () {
    $(this).parent().removeClass('loading');
	});
		});
	}
}
videoSize();
        
    //set height of team cta block
    
    $(window).on('load resize', function () {
    if($('.cta-box').length) {
      $('.cta-box').height($('.pre-cta img').height());
       }
});
    
    // cursor menu stuff
    $( document ).ready(function() {
     //const $cImg = $('#clipped-image');
// const $cVid = $('#clipped-video');
const $body = $('body');

      // menu mouse move
$body.mousemove(function(e) {
  
 // console.log('body detected');
// var $xme = e.pageX;
// var  $yme = e.pageY - $(document).scrollTop();
 // var  $new = $xme + 'px ' + $yme + 'px';
 // console.log('body' + $new);
// console.log('e.pagey' + e.pageY);
//  console.log('link1' + $('#main-link-1').offset().top);
//  console.log('link1' + $('#main-link-1').offset().top);
//  console.log('link1leftx' + e.pageX);
//   console.log('link1leftlink' + parseFloat($('#main-link-2 span').offset().left));
 //  console.log('link1left' +  parseFloat(e.pageX - $('#main-link-2 span').offset().left));
 $('#clipped-image').css('--clip-position', `${( parseFloat(e.pageX - $('#main-link-1 span').offset().left) + 20)}px ${(parseFloat(e.pageY - $('#main-link-1').offset().top + 5))}px`);
    $('#clipped-video').css('--clip-position', `${parseFloat(e.pageX - $('#main-link-1 span').offset().left)}px ${(parseFloat(e.pageY - $('#main-link-1 span').offset().top))}px`);
   $('#clipped-image-2').css('--clip-position', `${( parseFloat(e.pageX - $('#main-link-2 span').offset().left) + 10)}px ${(parseFloat(e.pageY - $('#main-link-2').offset().top + 5))}px`);
    $('#clipped-video-2').css('--clip-position', `${parseFloat(e.pageX - $('#main-link-2 span').offset().left)}px ${(parseFloat(e.pageY - $('#main-link-2 span').offset().top))}px`);
   $('#clipped-image-3').css('--clip-position', `${( parseFloat(e.pageX - $('#main-link-3 span').offset().left)+10)}px ${(parseFloat(e.pageY - $('#main-link-3').offset().top))}px`);
   $('#clipped-video-3').css('--clip-position', `${parseFloat(e.pageX - $('#main-link-3 span').offset().left)}px ${(parseFloat(e.pageY - $('#main-link-3 span').offset().top))}px`);
   $('#clipped-image-4').css('--clip-position', `${( parseFloat(e.pageX - $('#main-link-4 span').offset().left)+10)}px ${(parseFloat(e.pageY - $('#main-link-4').offset().top))}px`);
    $('#clipped-video-4').css('--clip-position', `${parseFloat(e.pageX - $('#main-link-4 span').offset().left + 60)}px ${(parseFloat(e.pageY - $('#main-link-4 span').offset().top))}px`);
   $('#clipped-image-5').css('--clip-position', `${( parseFloat(e.pageX - $('#main-link-5 span').offset().left)+ 10)}px ${(parseFloat(e.pageY - $('#main-link-5').offset().top))}px`);
  $('#clipped-video-5').css('--clip-position', `${parseFloat(e.pageX - $('#main-link-5 span').offset().left) + 60}px ${(parseFloat(e.pageY - $('#main-link-5 span').offset().top))}px`);
  $('#clipped-image-6').css('--clip-position', `${( parseFloat(e.pageX - $('#main-link-6 span').offset().left))}px ${(parseFloat(e.pageY - $('#main-link-6').offset().top))}px`);
  $('#clipped-video-6').css('--clip-position', `${parseFloat(e.pageX - $('#main-link-6 span').offset().left) + 60}px ${(parseFloat(e.pageY - $('#main-link-6 span').offset().top))}px`);
});
    });

    
    // end load video for mobile or desktop
    $( document ).ready(function() {
        gsap.registerPlugin(DrawSVGPlugin);
        gsap.registerPlugin(ScrollTrigger);
      
      // line hero video animation
       const line = gsap.timeline();
    line.to('.white-line', { duration: 0.5, delay: 1.5, opacity: 1, ease: 'power1.out'})
      .to('.white-line', { duration: 1.25, delay: 0.5, y: '86', height: 86, ease: 'power1.out', repeat: -1})
    .to('.white-line', { duration: 1.25, delay: 0, y: '172', height: 86, ease: 'power1.out', repeat: -1});
    
    const line2 = gsap.timeline();
    line2.to('.black-line', { duration: 0.5, delay: 1.5, opacity: 1, ease: 'power1.out'});
       // end line hero video animation
      
      
 let tload = gsap.timeline();
      tload.set('.nav-primary', {
    yPercent: -100,
    zIndex: '',
});
     var s = $(window).height()
      , o = $(window).width();
      let tcursor = gsap.timeline();
    tcursor.set($('.cursor'), {
        y: s / 2 - 40,
        x: o / 2 - 40,
    });
       let tcursor2 = gsap.timeline();
    tcursor2.set($('.circle-vid-container'), {
        y: s / 2 - 40,
        x: o / 2 - 40,
    });
      
    });
    
    /// main menu
    
    $('header .menu').on('click', function() {
       let tm = gsap.timeline();
      if($('body').hasClass('menu-visible')) {
  // close menu
    
              tm.to($('.main'),  {
        opacity: 1,
        scaleX: 1,
        scaleY: 1,
        duration: 0.5,
        ease: Power4.easeInOut,
        clearProps: 'all',
    }),
                   tm.to('.nav-primary ul > li', {
        opacity: 0,
       // y: -100,
        duration: 0,
        ease: Power4.easeOut,
        stagger: 0,
    }),
           tm.to('.nav-primary', {
        yPercent: -100,
        duration: 0.5,
                 delay: -0.5,
        ease: Power4.easeInOut,
        onComplete: resetMenu,
    }),
       
    tm.to('.menu #line-1',  {
        rotation: 0,
        y: 0,
        duration: 0.5,
        ease: Power4.easeInOut,
    }),
    tm.to('.menu #line-2',  {
        rotation: 0,
        y: 0,
        duration: 0.5,
        delay: -0.5,
        ease: Power4.easeInOut,
    })
        $('#main-link-2').removeClass('extra');
    $('#main-link-3').removeClass('extra');
  $('.services-menu-container').css('height', 0);
     $('#main-link-3').css('margin-top', 0);
     $('.mask-container .item').css('margin-top', 0);
     $('.services-menu-container').removeClass('show');
      } else {
        
        // open menu
            $('body').addClass('menu-visible'),
            $('.nav-primary').css('display', 'block');
        $('header').addClass('white');
 $('header').addClass('open');
      tm.to('.nav-primary',  {
        yPercent: 0,
        duration: 1,
        ease: Power4.easeInOut,
    }),
        tm.to('.menu #line-1', {
        rotation: 45,
        y: -5,
        duration: 0.3,
        ease: Power4.easeInOut,
    }),

    tm.to('.menu #line-2',  {
        rotation: 135,
        y: 5,
        duration: 0.3,
        delay: -0.3,
        ease: Power4.easeInOut,
    }),
     
    
/*   tm.to('.nav-content',  {
        opacity: 1,
        y: 0,
        duration: 0.5,
        delay: 0.5,
        ease: Power4.easeInOut,
    }),*/
    tm.to('.nav-primary #menu-main-menu > li', {
        opacity: 1,
        y: 0,
        duration: 0.6,
        delay: -0.6,
        ease: Power3.easeIn,
        stagger: 0.2,
    }),
        
        tm.fromTo($('.nav-content'), {opacity: 0}, {
        opacity: 1,
        duration: 0.5,
        ease: Power4.easeInOut,
    })
                               tm.to($('.main'), {
        opacity: .6,
        scaleX: .95,
        scaleY: .99,
        duration: 0,
        ease: Power4.easeInOut,
    })
        
      }
      
});
    
    
 function resetMenu() {

    $('.nav-primary').css('display', 'none');
   $('#nav-primary-second').css('display', 'none');
    $('.nav-primary-first').css('display', 'block');
     $('body').removeClass('menu-visible');
    $('header').removeClass('white');
   $('header').removeClass('black');
        $('header').removeClass('open');
}
    
    //open project menu 
    
     $('header .featured-project-menu').on('click', function() {
       $('.nav-primary-first').css('display', 'none');
       $('#nav-primary-second').css('display', 'block');
       $('header').removeClass('white');
        $('header').addClass('black');
     });
    $('footer .featured-project-menu').on('click', function() {
       $('.nav-primary-first').css('display', 'none');
       $('#nav-primary-second').css('display', 'block');
       $('header').removeClass('white');
        $('header').addClass('black');
      $('.nav-primary').css('display', 'block');
      $('.nav-primary').css('transform', 'translate(0%, 0)');
      $('body').addClass('menu-visible');
     });
    
    // end open project menu 
    
    // rollover project items
    
    $( '.color1' ).mouseover(function() {
 $('#nav-primary-second').removeClass().addClass('color1');
});
    
        $( '.color2' ).mouseover(function() {
 $('#nav-primary-second').removeClass().addClass('color2');
});
        $( '.color3' ).mouseover(function() {
 $('#nav-primary-second').removeClass().addClass('color3');
});
        $( '.color4' ).mouseover(function() {
 $('#nav-primary-second').removeClass().addClass('color4');
});
     $( '.color5' ).mouseover(function() {
 $('#nav-primary-second').removeClass().addClass('color5');
});
    
    
    // end rollover project items
    
    // end main menu
    
// fixed header 
 $( document ).ready(function() {
// scroll back header and hide scroll down
var lastScroll = 0;
var scroll;
$(window).scroll(function () {
 // $('.scroll-down').addClass('hide');
  
     if  ( $( 'body' ).hasClass('single-journal') || $( 'body' ).hasClass('single-services') ) {
          scroll = $(window).scrollTop();
       if (scroll > lastScroll && scroll >= 1) {
         if( !($('body').hasClass('menu-visible'))){
            $('header').addClass('sj');
         lastScroll = scroll;
       }
       }
       else {
         $('header').removeClass('sj');
          lastScroll = scroll;
       }
     }

     else if  ( $( 'body' ).hasClass('journal') ||  $( 'body' ).hasClass('page-featured-projects-data') ||  $( 'body' ).hasClass('page-press-data') ||  $( 'body' ).hasClass('people')) {
       scroll = $(window).scrollTop();
       if (scroll > lastScroll && scroll >= 150) {
         if( !($('body').hasClass('menu-visible'))){
            $('header').addClass('j');
         lastScroll = scroll;
         }
       }
       else {
         $('header').removeClass('j');
          lastScroll = scroll;
       }
     }
  else {
    scroll = $(window).scrollTop();
    if (scroll < 80) {
    $('header').removeClass('fix');

  }
  if ((scroll >= 80)) {
     $('header').addClass('fix');

  }
  }
});
// end scroll back header    
    
   });
    
// end fixed header     
    
     $( document ).ready(function() {
          var istouch = '';
       if ('ontouchstart' in document.documentElement)
{
  istouch = 'yes';
}
else
{
   istouch = 'no';
}
        $('.featured-project-item .project-picture').on('mouseenter', function() {
    //     console.log('featured');
   var w = window.innerWidth;  
    if (w >= 688) {
 if (istouch == 'no') {
      $(this).find('.one').addClass('hide');
       $(this).find('.two').addClass('show');
     //   console.log('second image source' +  $(this).find('img').attr('src'));
      
       $(this).addClass('active');
     gsap.to($( this ).find('.box-left'), {
       opacity: 1,
       duration: 0,
       delay: 0,
    });
      gsap.to($( this ).find('.box-right'), {
       opacity: 1,
       duration: 0,
        delay: 0,
    });
      gsap.to($( this ).find('.box-top'), {
       opacity: 1,
       duration: 0,
        delay: 0,
    });
       gsap.to($( this ).find('.box-bottom'), {
       opacity: 1,
       duration: 0,
         delay: 0,
    });
    }
        }
  } );

        $('.featured-project-item .project-picture').on('mouseleave', function() {
       //  console.log('featured');
   var w = window.innerWidth;  
    if (w >= 688) {
       if (istouch == 'no') {
             $(this).find('.two').removeClass('show');
      $(this).find('.one').removeClass('hide');

      $(this).removeClass('active');
     gsap.to($( this ).find('.box-left'), {
       opacity: 0,
       duration: 0,
       delay: 0,
    });
      gsap.to($( this ).find('.box-right'), {
       opacity: 0,
       duration: 0,
        delay: 0,
    });
      gsap.to($( this ).find('.box-top'), {
       opacity: 0,
       duration: 0,
        delay: 0,
    });
       gsap.to($( this ).find('.box-bottom'), {
       opacity: 0,
       duration: 0,
         delay: 0,
    });
    }
        }
  } );
       
    
       
               $('.featured-project-item .underline, .featured-project-item .btn').on('mouseenter', function() {
        // console.log('featured 2');
   var w = window.innerWidth;  
    if (w >= 688) {
      if (istouch == 'no') {
       
      $(this).parent().parent().find('.one').addClass('hide');
       $(this).parent().parent().find('.two').addClass('show');
       
       $(this).parent().parent().find('.two').addClass('active');
     gsap.to($(this).parent().parent().find('.two .box-left'), {
       opacity: 1,
       duration: 0,
       delay: 0,
    });
      gsap.to($(this).parent().parent().find('.two .box-right'), {
       opacity: 1,
       duration: 0,
        delay: 0,
    });
      gsap.to($(this).parent().parent().find('.two .box-top'), {
       opacity: 1,
       duration: 0,
        delay: 0,
    });
       gsap.to($(this).parent().parent().find('.two .box-bottom'), {
       opacity: 1,
       duration: 0,
         delay: 0,
    });
    }
    }
  } );

        $('.featured-project-item .underline, .featured-project-item .btn').on('mouseleave', function() {
       //  console.log('featured 2l');
   var w = window.innerWidth;  
    if (w >= 688) {
        if (istouch == 'no') {
      $(this).parent().parent().find('.one').removeClass('hide');
       $(this).parent().parent().find('.two').removeClass('show');
       
      
      $(this).parent().parent().find('.two').removeClass('active');
     gsap.to($(this).parent().parent().find('.two .box-left'), {
       opacity: 0,
       duration: 0,
       delay: 0,
    });
      gsap.to($(this).parent().parent().find('.two .box-right'), {
       opacity: 0,
       duration: 0,
        delay: 0,
    });
      gsap.to($(this).parent().parent().find('.two .box-top'), {
       opacity: 0,
       duration: 0,
        delay: 0,
    });
       gsap.to($(this).parent().parent().find('.two .box-bottom'), {
       opacity: 0,
       duration: 0,
         delay: 0,
    });
    }
    }
        
  } );
     });
    // end featured project rollover
    //slider section
    $( document ).ready(function() {
     var sliderSection = document.querySelector('.image-slider-container-2');
          
          if(sliderSection){
new SimpleBar(sliderSection, { autoHide: false, direction: 'ltr' });
          }

}); 
    
    // end slider section
    
    // services videos with text overlay
    $('.video-with-text-and-play svg').unbind('click').bind('click',function() {
        $(this).parent().parent().find('.overlay').addClass('hide');
       $(this).parent().parent().find('video').prop('controls', true); 
        $(this).parent().parent().find('video').trigger('play');
     });
    
    // end services videos with text overlay
    
    
    //image carousel
     /*$( document ).ready(function() {
      

      gsap.registerPlugin(DrawSVGPlugin);
          gsap.registerPlugin(ScrollTrigger);
  
var $slick = $('.image-carousel');
var mySpeed;
  $(function ($) {
        
$slick.slick({
  //  autoplay: true,
    dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
 centerMode: true,
  arrows: true,
  infinite: true,
  centerPadding: '20%',
    speed: 2000,
   prevArrow: '<a class="slick-prev prev" href="#"></a>',
  nextArrow: '<a class="slick-next next" href="#"></a>',
    customPaging : function(slider, i) {
  //  var thumb = $(slider.$slides[i]).data() ;
      i = i + 1;
    return '<a class="dot">0'+i+'</a><svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" class="small-dot"><circle id="Ellipse_4" data-name="Ellipse 4" cx="2" cy="2" r="2" fill="#252525"/></svg><svg xmlns="http://www.w3.org/2000/svg" class="circle-svg-2" width="58"  height="58" viewBox="0 0 58 58"><g id="circle" fill="none" stroke="#BFBFBF" stroke-width="2"><circle  class="circle-2" cx="29" cy="29" r="28" stroke="#BFBFBF" stroke-width="2"/></g></svg><svg xmlns="http://www.w3.org/2000/svg" class="circle-svg" width="58"  height="58" viewBox="0 0 58 58"><g id="circle" fill="none" stroke="#000000" stroke-width="2"><circle  class="circle" cx="29" cy="29" r="28" stroke="#000000" stroke-width="2"/></g></svg>';
            },
    responsive: [{ 
        breakpoint: 1200,
        settings: {
            slidesToShow: 1,
          centerMode: false,
        },
    }],
}).slickAnimation();
    
         var myTime = 10;
    const t1 = gsap.timeline({onComplete: startProgressbar2});    


     //  console.log('image');
       
     //  console.log(this);
       
       myTime = 10;
       
           if ( $( '.circle-svg' ).length ) {
            
       gsap.set('.circle-svg', {rotation:-90});
           }
       
       console.log('a');
              if ( $( '.circle' ).length ) {
                 console.log('b');
                $('.vid video').get(0).pause();
                 if ($('.slick-active .vid').length) {
         console.log('hi there');
         console.log('video found 2');
         console.log($('.slick-active .vid video'));
  myTime = 30;
  mySpeed = 5000;
  console.log(myTime);
   console.log(mySpeed);
       //  $('.vid video').stop();
  console.log('current index');
  console.log($('.slick-active').attr('data-slick-index'));
  //  $('.slick-slide[data-slick-index=""] .vid video').get(0).pause();
  //   $('.slick-active .vid video').get(0).play();
       }
    else {
      myTime = 10;
      mySpeed = 2000;
       console.log(mySpeed);
    }
       console.log('myTime before animate');
                console.log(myTime);
t1.from('.circle',  {duration: myTime, drawSVG:0, ease:'Linear.easeNone'});
                
              }
       
     
        

     function playt1() {
        console.log('c');
        t1.paused( false ); 
           $('.vid video').get(0).pause();

     }
  function startProgressbar() {
 console.log('d');
t1.progress(0);
$('.vid video').get(0).pause();

    
  }
 function startProgressbar2() {
    console.log('e');
     $('.vid video').get(0).pause();
$slick.slick('slickNext');

       startProgressbar();
    $('.image-carousel').slick('slickSetOption', 'autoPlayTimer', 0); 
   
  }
    
         $('.image-carousel .slick-dots').on('click', function() {
             startProgressbar();
           playt1();
           
         });
    
       $('.image-carousel .slick-next').on('click', function() {
             startProgressbar();
           playt1();
           
         });

       $('.image-carousel .slick-prev').on('click', function() {
             startProgressbar();
           playt1();
            //      $('.slider').slick('slickSetOption', 'autoPlayTimer', 0); 
         });
    

      
    
    $slick.on('init', function (event, slick, currentSlide) {
 console.log('f');
      if ($('.slide-video').hasClass('slick-active')) {
        var vid = $($slick.$slides[currentSlide]).find('video');
        if (vid.length > 0) {
      
          $slick.slick('slickPause');

          $(vid).get(0).play();

        }

      }
    });


  /*  $slick.on('afterChange', function (event, slick, currentSlide) {
       console.log('g');
      var vid = $($slick.$slides[currentSlide]).find('video');
      if (vid.length > 0) {

        $slick.slick('slickPause');

        $(vid).get(0).play();

      }

      
    });*/

    
/* $slick.on('afterChange', function(){
 console.log('h');
   console.log($slick);
     var dataId = $('.slick-current').attr('data-slick-index');    
    console.log(dataId);
  
  $('.slick-slide .vid video').each(function(){
    console.log($(this).parent());
    console.log($(this).parent().parent());
    console.log($(this).parent().parent().parent().attr('data-slick-index'));
    var pin = $(this).closest('.slick-slide').attr('data-slick-index');
    console.log(pin);
  //  var pin = $(this).parent().parent().attr('data-slick-index'); // Wrap 'this' with jQuery
    console.log(pin); 
    var pvid = $(this).closest('.slick-slide').find('.vid video');
    console.log(pvid);
   pvid.get(0).pause();
pvid.get(0).currentTime = 0;

 });
  if ($('.slick-current').find('video').length > 0) {
    
var vid = $('.slick-current').find('video');
      if (vid.length > 0) {

     //   $slick.slick('slickPause');

      $(vid).get(0).play();

      }
  }
   else {
     $slick.slick('slickPlay');
   }
});
    
    $slick.on('afterChange', function() {
    // Pause and reset all videos
    $('.slick-slide .vid video').each(function() {
        var videoElement = $(this).get(0);
        videoElement.pause();
        videoElement.currentTime = 0; // Reset to the first frame
    });

    // Find the current slide and check if it contains a video
    var currentSlideVideo = $('.slick-current').find('video');
    
    if (currentSlideVideo.length > 0) {
        // Play the video in the current slide
        currentSlideVideo.get(0).play();
    }
});
    
    // fix issue on the from last to first
    // Add custom class to next or previous slide depending on change direction
$slick.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    let nextIndex = currentSlide + 1; // assume moving right
    if(currentSlide-1 == nextSlide || (nextSlide+1 == slick.slideCount && currentSlide < nextSlide)) {
        nextIndex = currentSlide - 1; // nope, moving left
    }
    $(`[data-slick-index="${nextIndex}"]`).addClass('slick-target');
});

// clear custom class after transition
$slick.on('afterChange', () => {
    $('.slick-slide').removeClass('slick-target');
});
    
    // end fix

    $('video').bind('ended', function (e) {
 console.log('i');
      setTimeout(function () {
   
        e.target.currentTime = 0;
      //  e.target.pause();
  
      }, 100);

      $slick.slick('slickPlay');


    });
   });
  });*/
    // end image carousel
    $(document).ready(function () {
    gsap.registerPlugin(DrawSVGPlugin);
    gsap.registerPlugin(ScrollTrigger);

    var $slick = $('.image-carousel');
var myTime = 10; // Default duration in seconds
var slideTimer; // Declare slideTimer here
let t1; // Declare t1 at the top so it's accessible throughout the script
let isAnimating = false; // Flag to track if animation is in progress
console.log('my time on load' + myTime);

// Initialize the slick carousel
$slick.slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    infinite: true,
    centerPadding: '19%',
    speed: 2000,
    autoplay: true, // Enable autoplay
    autoplaySpeed: myTime * 1000, // Set initial autoplay speed to 10 seconds
    prevArrow: '<a class="slick-prev prev" href="#"></a>',
    nextArrow: '<a class="slick-next next" href="#"></a>',
    customPaging: function (slider, i) {
        i = i + 1;
        return '<a class="dot">0' + i + '</a>' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" class="small-dot">' +
            '<circle id="Ellipse_4" data-name="Ellipse 4" cx="2" cy="2" r="2" fill="#252525"/></svg>' +
            '<svg xmlns="http://www.w3.org/2000/svg" class="circle-svg-2" width="58" height="58" viewBox="0 0 58 58">' +
            '<g id="circle" fill="none" stroke="#BFBFBF" stroke-width="2">' +
            '<circle class="circle-2" cx="29" cy="29" r="28" stroke="#BFBFBF" stroke-width="2"/></g></svg>' +
            '<svg xmlns="http://www.w3.org/2000/svg" class="circle-svg" width="58" height="58" viewBox="0 0 58 58">' +
            '<g id="circle" fill="none" stroke="#000000" stroke-width="2">' +
            '<circle class="circle" cx="29" cy="29" r="28" stroke="#000000" stroke-width="2"/></g></svg>';
    },
    /*responsive: [{
        breakpoint: 1360,
        settings: {
            centerMode: false,
        },
    }],*/
}).slickAnimation();

// Start the progress bar when the slick carousel is initialized
$slick.on('init', function () {
    // startProgressbar();
});

// Immediately start the progress bar after initializing slick
startProgressbar();

// Reset the progress bar and timer after each slide change
$slick.on('afterChange', function () {
    startProgressbar();
});

// Pause and reset the video when the slide is no longer active
$slick.on('beforeChange', function (event, slick, currentSlide) {
    var currentVideo = $(slick.$slides[currentSlide]).find('video');
    if (currentVideo.length) {
        currentVideo.get(0).pause();
        currentVideo.get(0).currentTime = 0;
    }
});

// Handle manual navigation (dots and arrows)
$('body').on('click', '.image-carousel .slick-dots, .image-carousel .slick-next, .image-carousel .slick-prev', function () {
    clearTimeout(slideTimer);
    isAnimating = false;
    startProgressbar();
});
      
$('.image-carousel').on('swipe', function(event, slick, direction){
  console.log(direction);
  clearTimeout(slideTimer);
    isAnimating = false;
    startProgressbar();
  // left
});

// Bind the video ended event to transition to the next slide
$('video').on('ended', function () {
    $slick.slick('slickNext');
});

// Start the slick carousel

  function waitForVideo(){
    console.log('vhere2');
    console.log(document.querySelector('body .slick-active .vid video'));
       console.log(document.querySelector('body .slick-active .vid video').duration);
    console.log(document.querySelector('.slick-active .vid video source').duration);
    if(isNaN(document.querySelector('.slick-active .vid video').duration) || document.querySelector('.slick-active .vid video').duration === 'undefined' ){
       console.log('vhere22');
    //  $slick.slick('slickPause');
        //variable exists, do what you want
      setTimeout(waitForVideo, 250);
    }
    else{
        myTime = document.querySelector('.slick-active .vid video').duration;
      $('.slick-active .vid video').attr('playsinline',''); 
      $('.slick-active .vid video').prop('muted', true); 
        $('.slick-active .vid video').get(0).play(); 
      
    }
}
// Function to start the progress bar animation
function startProgressbar() {
    if (isAnimating) return;
    isAnimating = true;

    if (slideTimer) {
        clearTimeout(slideTimer);
    }

    if ($('.slick-active .vid').length) {
      console.log('found');
      waitForVideo();
 /*     var video = $('.slick-active .vid video').get(0);

if (video) {
  // Event listener for canplay
  video.addEventListener('canplay', function() {

  video.play().catch(function(error) {
    console.error('Playback failed:', error);
  });

  });

  // Polling mechanism with setInterval
  var checkReadyInterval = setInterval(function() {
    if (video.readyState >= 3) { // Video is ready to play (3 = HAVE_FUTURE_DATA)
       video.play().catch(function(error) {
    console.error('Playback failed:', error);
  });
      clearInterval(checkReadyInterval); // Stop checking once it plays
    }
  }, 500); // Check every 500ms
}
*/

    } else {
        console.log('not found');
        myTime = 10;
    }

    console.log('myTime set to:', myTime);
    $slick.slick('slickSetOption', 'autoplaySpeed', myTime * 1000, true);

    gsap.set('.circle', {
        drawSVG: '0%',
        rotation: -90,
        transformOrigin: 'center center',
    });

    if (t1) {
        t1.kill();
    }
    t1 = gsap.timeline({
        onComplete: () => {
            isAnimating = false;
            gsap.set('.circle', {
                drawSVG: '0%',
                rotation: -90,
                transformOrigin: 'center center',
            });
            slideToNext();
        },
    });

    t1.to('.circle', {
        duration: myTime,
        drawSVG: '0% 100%',
        ease: 'Linear.easeNone',
    });

    slideTimer = setTimeout(function () {
        $slick.slick('slickNext');
    }, myTime * 1000);
}

function slideToNext() {
    if ($slick.slick('slickCurrentSlide') === $('.slick-active').index()) {
        $slick.slick('slickNext');
    }
}

});

// cursors
    $(document).on('mousemove', function(s) {
        let tcursor = gsap.timeline();
        tcursor.set($('.cursor'), {
            force3D: !1,
            y: s.clientY - $('.cursor').height() / 2,
            x: s.pageX - $('.cursor').width() / 2,
        });
      
      let tcursor2 = gsap.timeline();
        tcursor2.set($('.circle-vid-container'), {
            force3D: !1,
            y: s.clientY - $('.circle-vid-container').height() / 2,
            x: s.pageX - $('.circle-vid-container').width() / 2,
        })
    });
    

  
     $('a:not(.main-link), header .menu, input[type="submit"], #service-list li, .service h2, .video-with-text-and-play svg').on('mouseenter', function() {
    //   console.log('here');
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .5,
            scaleY: .5,
        })
    });
        var istouch = '';
       if ('ontouchstart' in document.documentElement)
{
  istouch = 'yes';
}
else
{
   istouch = 'no';
}
if (istouch != 'yes') {
  document.getElementById('close-service-menu').addEventListener('click', function(e) {
    e.preventDefault();
    $('#main-link-2').removeClass('extra');
    $('#main-link-3').removeClass('extra');
     $('.services-menu-container').css('height', 0);
     $('#main-link-3').css('margin-top', 0);
     $('.mask-container .item').css('margin-top', 0);
     $('.services-menu-container').removeClass('show');
  });
   
  document.getElementById('main-link-2').addEventListener('click touchstart', function(e) {
    e.preventDefault();
 console.log('service menu click');
  //  console.log($('.services-menu-container-inner').height());
    // services menu
   var serviceHeight = $('.services-menu-container-inner').height();
    serviceHeight = serviceHeight + 14;
   if($('.services-menu-container').hasClass('show')) {
          $('#main-link-2').removeClass('extra');
    $('#main-link-3').removeClass('extra');
      $('.services-menu-container').css('height', 0);
     $('#main-link-3').css('margin-top', 0);
     $('.mask-container .item').css('margin-top', 0);
     $('.services-menu-container').removeClass('show');
   }
    else {
        $('#main-link-2').addClass('extra');
    $('#main-link-3').addClass('extra');
       $('.services-menu-container').css('height',serviceHeight);
       $('#main-link-3').css('margin-top',serviceHeight );
       $('.mask-container .item-1').css('margin-top', '-90px');
      $('.mask-container .item-2').css('margin-top', '-150px');
      $('.mask-container .item-lower').css('margin-top', serviceHeight);
      $('.mask-container .item-3').css('margin-top', serviceHeight + 120);
      $('.mask-container .item-4').css('margin-top', serviceHeight + 60);
       $('.services-menu-container').addClass('show');
    }
  });
    
     $('#main-link-1 span').on('mouseenter', function() {
    //   console.log('link 1 here');
          if($('.mask-container').hasClass('i-active')) {
        $('.item-1').addClass('show next');
          }
       else {
         $('.item-1').addClass('show');
       }
        setTimeout(function() {
    $('.mask-container').addClass('i-active');
    }, 300);
       
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: 0,
            scaleY: 0,
        })
    });
        $('#main-link-2 span').on('mouseenter', function() {
     //  console.log('link 2 here');
           if($('.mask-container').hasClass('i-active')) {
        $('.item-2').addClass('show next');
           }
          else {
             $('.item-2').addClass('show'); 
          }
       setTimeout(function() {
    $('.mask-container').addClass('i-active');
    }, 300);
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: 0,
            scaleY: 0,
        })
    });
    
    $('#main-link-3 span').on('mouseenter', function() {
    //   console.log('link 3 here');
             if($('.mask-container').hasClass('i-active')) {
        $('.item-3').addClass('show next');
             }
      else {
             $('.item-3').addClass('show');
      }
setTimeout(function() {
    $('.mask-container').addClass('i-active');
    }, 300);
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: 0,
            scaleY: 0,
        })
    });
    
    $('#main-link-4 span').on('mouseenter', function() {
    //   console.log('link 4 here');
      if($('.mask-container').hasClass('i-active')) {
         $('.item-4').addClass('show next');
      }
       else {
          $('.item-4').addClass('show');
       }
     setTimeout(function() {
    $('.mask-container').addClass('i-active');
    }, 300);
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: 0,
            scaleY: 0,
        })
    });
    $('#main-link-5 span').on('mouseenter', function() {
    //   console.log('link 5 here');
       if($('.mask-container').hasClass('i-active')) {
        $('.item-5').addClass('show next');
       }
      else {
         $('.item-5').addClass('show');
      }
      setTimeout(function() {
    $('.mask-container').addClass('i-active');
    }, 300);
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: 0,
            scaleY: 0,
        })
    });
  $('#main-link-6 span').on('mouseenter', function() {
    //   console.log('link 6 here');
      if($('.mask-container').hasClass('i-active')) {
         $('.item-6').addClass('show next');
      }
       else {
          $('.item-6').addClass('show');
       }
     setTimeout(function() {
    $('.mask-container').addClass('i-active');
    }, 300);
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: 0,
            scaleY: 0,
        })
    });
}
    //dynamically generated detection
    $('.image-carousel').on('mouseenter', 'li', function() {
       console.log('here n');
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .5,
            scaleY: .5,
        })
    });
    

    $('a:not(.main-link), header .menu, input[type="submit"], #service-list li, .service h2, .video-with-text-and-play svg').on('mouseleave', function() {
            let tcursor = gsap.timeline();
     tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
    if (istouch != 'yes') {
    $('#main-link-1 span').on('mouseleave', function() {
      $('.item-1').removeClass('show next');
      if($('#main-link-1 span:hover').length === 0 && $('#main-link-2 span:hover').length === 0 && $('#main-link-3 span:hover').length === 0 && $('#main-link-4 span:hover').length === 0 && $('#main-link-5 span:hover').length === 0 && $('#main-link-6 span:hover').length === 0){
          $('.mask-container').removeClass('i-active');
      }
            let tcursor = gsap.timeline();
     tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
      $('#main-link-2 span').on('mouseleave', function() {
      $('.item-2').removeClass('show next');
    if($('#main-link-1 span:hover').length === 0 && $('#main-link-2 span:hover').length === 0 && $('#main-link-3 span:hover').length === 0 && $('#main-link-4 span:hover').length === 0 && $('#main-link-5 span:hover').length === 0 && $('#main-link-6 span:hover').length === 0){
          $('.mask-container').removeClass('i-active');
      }
            let tcursor = gsap.timeline();
     tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
     $('#main-link-3 span').on('mouseleave', function() {
      $('.item-3').removeClass('show next');
  if($('#main-link-1 span:hover').length === 0 && $('#main-link-2 span:hover').length === 0 && $('#main-link-3 span:hover').length === 0 && $('#main-link-4 span:hover').length === 0 && $('#main-link-5 span:hover').length === 0 && $('#main-link-6 span:hover').length === 0){
          $('.mask-container').removeClass('i-active');
      }
            let tcursor = gsap.timeline();
     tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
     $('#main-link-4 span').on('mouseleave', function() {
      $('.item-4').removeClass('show next');
       if($('#main-link-1 span:hover').length === 0 && $('#main-link-2 span:hover').length === 0 && $('#main-link-3 span:hover').length === 0 && $('#main-link-4 span:hover').length === 0 && $('#main-link-5 span:hover').length === 0 && $('#main-link-6 span:hover').length === 0){
          $('.mask-container').removeClass('i-active');
      }
            let tcursor = gsap.timeline();
     tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
     $('#main-link-5 span').on('mouseleave', function() {
      $('.item-5').removeClass('show next');
        if($('#main-link-1 span:hover').length === 0 && $('#main-link-2 span:hover').length === 0 && $('#main-link-3 span:hover').length === 0 && $('#main-link-4 span:hover').length === 0 && $('#main-link-5 span:hover').length === 0 && $('#main-link-6 span:hover').length === 0 ){
          $('.mask-container').removeClass('i-active');
      }
            let tcursor = gsap.timeline();
     tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
        $('#main-link-6 span').on('mouseleave', function() {
      $('.item-6').removeClass('show next');
        if($('#main-link-1 span:hover').length === 0 && $('#main-link-2 span:hover').length === 0 && $('#main-link-3 span:hover').length === 0 && $('#main-link-4 span:hover').length === 0 && $('#main-link-5 span:hover').length === 0 && $('#main-link-6 span:hover').length === 0){
          $('.mask-container').removeClass('i-active');
      }
            let tcursor = gsap.timeline();
     tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
    }
        $('.image-carousel').on('mouseleave', 'li', function() {
       console.log('here n');
             let tcursor = gsap.timeline();
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
    
     $('.three-images').on('mouseenter', function() {
              let tcursor = gsap.timeline();
        $('.cursor').addClass('rotate'),
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .5,
            scaleY: .5,
        })
    });
    $('.three-images').on('mouseleave', function() {
              let tcursor = gsap.timeline();
        $('.cursor').removeClass('rotate'),
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
    
    
    $('.image-carousel').on('mouseenter', '.slick-prev', function() {     
        console.log('prev');
              let tcursor = gsap.timeline();
        $('.cursor').addClass('prev'),
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .75,
            scaleY: .75,
        })
    });
    
    
    $('.image-carousel').on('mouseleave', '.slick-prev', function() {   
         console.log('prev ex');
              let tcursor = gsap.timeline();
        $('.cursor').removeClass('prev'),
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
         $('.image-carousel').on('mouseenter', '.slick-next', function() {   
               console.log('next');
              let tcursor = gsap.timeline();
        $('.cursor').addClass('next'),
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .75,
            scaleY: .75,
        })
    });
   $('.image-carousel').on('mouseleave', '.slick-next', function() {  
         console.log('next ex');
              let tcursor = gsap.timeline();
        $('.cursor').removeClass('next'),
        tcursor.to($('.cursor .pointer'), .25, {
            scaleX: .1,
            scaleY: .1,
        })
    });
    


    // end cursors
    

    // home page hero 
        $( document ).ready(function() {
          
       if  ( $( 'body' ).hasClass('front-page-data')) {
     gsap.registerPlugin(ScrollTrigger);
 let therohome = gsap.timeline();
         
     //    therohome.set('.hero-text h3', {animation: 'none'})
      //        therohome.set('.hero-text h1', {animation: 'none'})
    therohome.fromTo('.hero-text h3', {opacity: 1}, {
scrollTrigger: {
 trigger: '.featured',
start: 'top 25%',
toggleActions: 'play complete play reset',
  // markers: true,
},
opacity: 0,
      zIndex: -1,
      duration: 0.1,
       ease: Power3.easeOut,
     animation: 'none',
});
             therohome.fromTo('.hero-text h1', {opacity: 1}, {
scrollTrigger: {
 trigger: '.featured-text',
start: 'top center-=48',
toggleActions: 'play complete play reset',
   // markers: true,
},
opacity: 0,
      zIndex: -1,
      duration: 0.1,
       ease: Power3.easeOut, 
               animation: 'none',
});
  therohome.fromTo('.hero-text', {opacity: 1}, {
scrollTrigger: {
 trigger: '.featured-text',
start: 'top center-=48',
toggleActions: 'play complete reverse reset',
   // markers: true,
},
      zIndex: -1,
      duration: 0.1,
       ease: Power3.easeOut, 
})
          
          let tfeathome = gsap.timeline();
    tfeathome.to('.featured-text', {
scrollTrigger: {
 trigger: '.featured-text',
start: 'top center-=48',
toggleActions: 'play reverse play reset',
   // markers: true,
},
opacity: 1,
      duration: 0.1,
});
/*             tfeathome.fromTo('.featured-text a', { opacity: 0, yPercent: 20 }, {
scrollTrigger: {
 trigger: '.featured-text',
start: 'top center-=48',
 // end: '+=50',
toggleActions: 'play reverse play reverse',
   // markers: true,
},
opacity: 1, 
    yPercent: 0,
      duration: 0.1,
});*/
 }

        });
    // end home page hero
    
    
    // design philosophy page 
        $( document ).ready(function() {
          if($('.two-images-text-and-background-container').length ) {
            var w = window.innerWidth; 
        //   const heightDiff = document.getElementById('parallax-content').offsetHeight - document.getElementById('section-parallax-container').offsetHeight;
    //      const height = document.getElementById('two-images-text-and-background-container').offsetHeight;
    //      const height2 = document.getElementById('section-parallax-container').offsetHeight;
         // console.log(heightDiff);
     //      console.log(height);
     //     console.log(height2);
           var position = $('.two-images-text-and-background-container').offset().top;
 // console.log(position);
       //         var adjPosition = position / 3;
    //     adjPosition = adjPosition+'px';
    var adjPosition2 = '-'+(position / 10);
             var adjPosition3 = '+='+(position / 1.5);
                 var adjPosition4 = (position / 10);
          position = position - 120;
  position = '-'+ position +'px';
  //  console.log(position);
          
        //  adjPosition = position / 3;
    if (w >= 1360) {
      
            if ( $( '.two-images-text-and-background-container' ).length ) {
              
              $('.left-image').css('margin-top', adjPosition4);
           $('.right-image').css('margin-top', adjPosition2);
                          $('.bottom').css('margin-top', adjPosition4);  
     gsap.registerPlugin(ScrollTrigger);
let tphilos = gsap.timeline();
         
             // set up layers based on dataset depth 
      const tl = gsap.timeline({
	scrollTrigger: {
		trigger: '.two-images-text-and-background-container',
		start: 'top 120px',
		end: 'bottom top',
		scrub: 0.5,
  //  markers: true,
    toggleActions: 'play complete reverse reset',
	},
});
//tl.set('.layer-2-2',{ position: 'absolute', top: 0, marginTop: 0 });

gsap.utils.toArray('.two-images-text-and-background-container .parallax').forEach(layer => {
	const depth = layer.dataset.depth;
	const movement = -(layer.offsetHeight * depth)
	tl.to(layer, {y: movement, ease: 'none'}, 0)
});
     
              // fix the o at the top of page
const tl3 = gsap.timeline({
	scrollTrigger: {
		trigger: '.two-images-text-and-background-container',
		start: 'top 120px',
		end: 'top 121px',
		scrub: false,
//markers: {startColor: 'pink', endColor: 'green'},
    toggleActions: 'play complete reverse reset',
	},
});
tl3.to($('.two-images-text-and-background-container .layer-2'),{  marginTop: position, position: 'fixed', top: 'inherit', left: 0 }, 0.0001);
         //fix the title and intro     
 gsap.timeline({
	scrollTrigger: {
		trigger: '.two-images-text-and-background-text .container',
    pin: '.two-images-text-and-background-text .container',
		start: 'top 100px',
 // endTrigger: '.right-image',
		end: adjPosition3,
		scrub: 0.5,
 //markers: {startColor: 'red', endColor: 'yellow'},
    toggleActions: 'play complete reverse reset',
	},
});
     
              
         //    var positionP = $('.image-title-overlay').offset().top;
  // console.log(positionP);
 // positionP = '-'+ positionP +'px';
  // console.log(positionP);
  const tp = gsap.timeline({
	scrollTrigger: {
		trigger: '.image-title-overlay',
		start: 'top bottom',
		end: 'bottom top',
		scrub: 0.5,
//markers: {startColor: 'pink', endColor: 'green'},
    toggleActions: 'play complete reverse reset',
	},
});
//tl.set('.layer-2-2',{ position: 'absolute', top: 0, marginTop: 0 });

gsap.utils.toArray('.image-title-overlay .parallax').forEach(layer => {
	const depth = layer.dataset.depth;
	const movement = -(layer.offsetHeight * depth)
	tp.to(layer, {y: movement, ease: 'none'}, 0)
});
   
              
              
       tphilos.fromTo('.image-title-overlay .title-overlay h2.left-item', { x: '-200%' }, {
scrollTrigger: {
 trigger: '.image-title-overlay .title-overlay h2',
start: 'top 60%',
    end: 'top 40%',
   scrub: 0.5,
 // pin: true,
toggleActions: 'play complete reverse reset',
//markers: {startColor: 'red', endColor: 'yellow'},
},
x: '0%',
       ease: Power3.easeOut,
})   
              

       
                     tphilos.fromTo('.image-title-overlay .title-overlay h2.right-item', { x: '200%' }, {
scrollTrigger: {
 trigger: '.image-title-overlay .title-overlay h2',
start: 'top 60%',
    end: 'top 40%',
   scrub: 0.5,
 // pin: true,
toggleActions: 'play complete reverse reset',
//markers: true,
},
x: '0%',
       ease: Power3.easeOut,
})
              

 }
    }
          
        else  if (w >= 992 && w < 1360) {
          let tphilos = gsap.timeline();
               //     var positionP = $('.image-title-overlay').offset().top;
 // console.log(positionP);
 //`` positionP = '-'+ positionP +'px';
 //   console.log(positionP);
  const tp = gsap.timeline({
	scrollTrigger: {
		trigger: '.image-title-overlay',
		start: 'top bottom',
		end: 'bottom top',
		scrub: 0.5,
//markers: {startColor: 'pink', endColor: 'green'},
    toggleActions: 'play complete reverse reset',
	},
});
//tl.set('.layer-2-2',{ position: 'absolute', top: 0, marginTop: 0 });

gsap.utils.toArray('.image-title-overlay .parallax').forEach(layer => {
	const depth = layer.dataset.depth;
	const movement = -(layer.offsetHeight * depth)
	tp.to(layer, {y: movement, ease: 'none'}, 0)
});
   
              
              
       tphilos.fromTo('.image-title-overlay .title-overlay h2.left-item', { x: '-200%' }, {
scrollTrigger: {
 trigger: '.image-title-overlay img',
start: 'top 60%',
    end: 'top 40%',
   scrub: 0.5,
 // pin: true,
toggleActions: 'play complete reverse reset',
//markers: {startColor: 'red', endColor: 'yellow'},
},
x: '0%',
       ease: Power3.easeOut,
})   
              

       
                     tphilos.fromTo('.image-title-overlay .title-overlay h2.right-item', { x: '200%' }, {
scrollTrigger: {
 trigger: '.image-title-overlay',
start: 'top 60%',
    end: 'top 40%',
   scrub: 0.5,
 // pin: true,
toggleActions: 'play complete reverse reset',
//markers: true,
},
x: '0%',
       ease: Power3.easeOut,
})
          
        }
          }
        });
// end design philosophy page 
    
        // scrolldown
     /*$( document ).ready(function() {
        gsap.registerPlugin(DrawSVGPlugin);
      var curScroll2;  
      curScroll2 = $(window).scrollTop();
  //    console.log(curScroll2);
      if (curScroll2 == 0) {
      var $scrollDown = $('.scrolldown');
       setTimeout(function() {
       $scrollDown.removeClass('hide');
   }, 3000);
      }

    });*/
    
 /*      $(window).scroll(function () {
  $('.scrolldown').addClass('hide');
    });*/
    
    // end scroll down
    
    
        // fix image-left-text-right
    
           $( document ).ready(addFixedRight);
    $(window).on('resize',addFixedRight);
function addFixedRight() {

      var w = window.innerWidth;  
    if (w >= 1200) {
            if ( $( '.image-left-text-right .text-right-container' ).length ) {
              
     gsap.to('.image-left-text-right .text-right-container', {
      scrollTrigger:  {
        trigger: '.image-left-text-right .text-right-container', 
        start: 'top 134px',
        pin: true,
        scrub: 0.5,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '.image-left-text-right img', // end after scrolling 500px beyond the start
      end: 'bottom center',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 // markers: true,
       toggleActions: 'reverse',
      },
    });
     
    }

}

}
        // end fix image-left-text-right
    
  
      $(window).on('resize',serviceMenuResize);
    function serviceMenuResize() {
     var serviceHeight = $('.services-menu-container-inner').height();
    serviceHeight = serviceHeight + 32;
   if($('.services-menu-container').hasClass('show')) {
     $('.services-menu-container').css('height',serviceHeight);
       $('#main-link-3').css('margin-top',serviceHeight );
      $('.mask-container .item-lower').css('margin-top', serviceHeight);
   }
    }
      // start fixed-left-image
        $( document ).ready(addFixedLeft);
    $(window).on('resize',addFixedLeft);
function addFixedLeft() {

      var w = window.innerWidth;  
    if (w >= 992) {
     gsap.to('#fixed-left-image .freeze', {
      scrollTrigger:  {
        trigger: '#fixed-left-image .freeze', 
       start: 'top 134px',
        pin: true,
// pinSpacing: true,
 pinReparent: true,
      endTrigger: '#fixed-left-image .unfreeze', // end after scrolling 500px beyond the start
      end: 'bottom bottom',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 // markers: true,
       toggleActions: 'reverse',
        scrub: true,
      },
    });
     
    }
}


    
// end fixed-left-image

   //  fixed-left-image scroll right
     $( document ).ready(addFixedLeftRight);
    $(window).on('resize',addFixedLeftRight);
function addFixedLeftRight() {

      var w = window.innerWidth;  
    if (w >= 688) {
     gsap.to('#fixed-left-scroll-right .featured', {
      scrollTrigger:  {
        trigger: '#fixed-left-scroll-right .featured', 
       start: 'top 176px',
        pin: true,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#fixed-left-scroll-right .unfreeze', // end after scrolling 500px beyond the start
      end: 'bottom bottom',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 // markers: true,
       toggleActions: 'reverse',
        scrub: true,
      },
    });
     
    }
}
       //  end fixed-left-image scroll right
    
     //  horizontal line
     $( document ).ready(addHorizontal);
    $(window).on('resize',addHorizontal);
function addHorizontal() {

      var w = window.innerWidth;  
    if (w >= 688) {
     gsap.to('#horizontal .divide', {
      scrollTrigger:  {
        trigger: '#horizontal .divide', 
       start: 'top+=200px bottom',
  //      pin: true,
// pinSpacing: true,
// pinReparent: true,
    //  endTrigger: '#fixed-left-scroll-right .unfreeze', // end after scrolling 500px beyond the start
    //  end: 'bottom center',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 // markers: true,
     //  toggleActions: 'reverse',
      //  scrub: true,
      },
       width: '100%',
       duration: 1,
    });
     
    }
}
       //  horizontal line
    
         //  vertical line
     $( document ).ready(addVertical);
    $(window).on('resize',addVertical);
function addVertical() {

      var w = window.innerWidth;  
    if (w >= 992) {
     gsap.to('#image-and-quote .divide2', {
      scrollTrigger:  {
        trigger: '#image-and-quote', 
       start: 'top center',
  //      pin: true,
// pinSpacing: true,
// pinReparent: true,
    //  endTrigger: '#fixed-left-scroll-right .unfreeze', // end after scrolling 500px beyond the start
    //  end: 'bottom center',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 // markers: true,
     //  toggleActions: 'reverse',
      //  scrub: true,
      },
       height: '100%',
       duration: 1,
    });
     
    }
}
       //  end vertical line
    
    
    // box
     $( document ).ready(addBox);
    $(window).on('resize',addBox);
function addBox() {

      var w = window.innerWidth;  
    if (w >= 688) {
     gsap.to('#fixed-left-scroll-right .box-left', {
       height: '100%',
       duration: 1,
       delay: 1,
    });
      gsap.to('#fixed-left-scroll-right .box-right', {
       height: '100%',
       duration: 1,
        delay: 1,
    });
      gsap.to('#fixed-left-scroll-right .box-top', {
       width: '100%',
       duration: 1,
        delay: 1,
    });
       gsap.to('#fixed-left-scroll-right .box-bottom', {
       width: '100%',
       duration: 1,
         delay: 1,
    });
    }
}
    
    // end box
    // fix team menu
    
           $( document ).ready(addFixedTeam);
    $(window).on('resize',addFixedTeam);
function addFixedTeam() {

      var w = window.innerWidth;  
    if (w >= 992) {
            if ( $( '.team-menu' ).length ) {
     gsap.to('.team-menu', {
      scrollTrigger:  {
        trigger: '.team-menu', 
        start: 'top 134px',
        pin: true,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '.the-team', // end after scrolling 500px beyond the start
      end: 'bottom bottom-=300px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
// markers: true,
       toggleActions: 'reverse',
        scrub: true,
      },
    });
     
    }
}

}
        // end fix team menu
    
    // team menu links 
    
    $('.team-link').click(function() {
      var href = $(this).attr('href');
    //   var myOffset = { top: '-200px', left: '0px' };
   //  console.log(myOffset);
    //  console.log(href);
      
       $('html, body').animate({
        scrollTop: parseInt($(href).offset().top -120),
    }, 2000);
  event.preventDefault();
});
    
  
    // end team menu links
    
    
    // team menu - highlight team
    
    $( document ).ready(function() {
           var w = window.innerWidth;  
        if (w >= 992) {
            if ( $( '#team-1' ).length ) {
     gsap.to('.team-1', {
      scrollTrigger:  {
        trigger: '#team-1', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-1', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-1', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
                      if ( $( '#team-2' ).length ) {
     gsap.to('.team-2', {
      scrollTrigger:  {
        trigger: '#team-2', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-2', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-2', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
                                if ( $( '#team-3' ).length ) {
     gsap.to('.team-3', {
      scrollTrigger:  {
        trigger: '#team-3', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-3', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-3', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }

               if ( $( '#team-4' ).length ) {
     gsap.to('.team-4', {
      scrollTrigger:  {
        trigger: '#team-4', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-4', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-4', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }

                                 if ( $( '#team-5' ).length ) {
     gsap.to('.team-5', {
      scrollTrigger:  {
        trigger: '#team-5', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-5', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-5', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }

           if ( $( '#team-6' ).length ) {
     gsap.to('.team-6', {
      scrollTrigger:  {
        trigger: '#team-6', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-6', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-6', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
          
             if ( $( '#team-7' ).length ) {
     gsap.to('.team-7', {
      scrollTrigger:  {
        trigger: '#team-7', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-7', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-7', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
             if ( $( '#team-8' ).length ) {
     gsap.to('.team-8', {
      scrollTrigger:  {
        trigger: '#team-8', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-8', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-8', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
             if ( $( '#team-9' ).length ) {
     gsap.to('.team-9', {
      scrollTrigger:  {
        trigger: '#team-9', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-9', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-9', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
             if ( $( '#team-10' ).length ) {
     gsap.to('.team-10', {
      scrollTrigger:  {
        trigger: '#team-10', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-10', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-10', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
             if ( $( '#team-11' ).length ) {
     gsap.to('.team-11', {
      scrollTrigger:  {
        trigger: '#team-11', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-11', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-11', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
             if ( $( '#team-12' ).length ) {
     gsap.to('.team-12', {
      scrollTrigger:  {
        trigger: '#team-12', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-12', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-12', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
             if ( $( '#team-13' ).length ) {
     gsap.to('.team-13', {
      scrollTrigger:  {
        trigger: '#team-13', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-13', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-13', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
             if ( $( '#team-14' ).length ) {
     gsap.to('.team-14', {
      scrollTrigger:  {
        trigger: '#team-14', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-14', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-14', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
             if ( $( '#team-15' ).length ) {
     gsap.to('.team-15', {
      scrollTrigger:  {
        trigger: '#team-15', 
        start: 'top top+=200px',
        pin: false,
// pinSpacing: true,
// pinReparent: true,
      endTrigger: '#team-15', // end after scrolling 500px beyond the start
      end: 'bottom top+=200px',
    //  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //    anticipatePin: 1,e
 //markers: true,
       toggleActions: 'reverse',
        scrub: true,
      toggleClass: {targets: '.team-15', className: 'selected'},
      },
     //  color: '#000',
    });
     
    }
}
      

    });
    
        // end team menu - highlight team
    
    // team mobile read more
    
     $(document).ready(function(){
         var w = window.innerWidth;  
        if (w < 992) {
    var maxLength = 170;
              var myStr ='';
          var myStr2 ='';
          var myStr3 ='';
          var myStr4 ='';
          var myStr5 ='';
          var myStr6 ='';
    $('#team-1 .team-content').each(function(){
if ($(this).text.length > 0) {
        myStr = $(this).html();
        if($.trim(myStr).length > maxLength){
            var newStr = myStr.substring(0, maxLength);
            var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
            $(this).empty().html(newStr +' <a href="javascript:void(0);" class="read-more">...read more</a>' );
          //  $(this).append(' <a href="javascript:void(0);" class="read-more">...Read More</a>');
            $(this).append('<span class="more-text">' + removedStr + '</span>');
        }
}
    });
    $('#team-1 .read-more').click(function(){
    //    $(this).siblings('.more-text').contents().unwrap();
 $('#team-1 .team-content').replaceWith(myStr);
  // $('.woocommerce-product-details__short-description p')[0].normalize();
 
// $.trim($(this).parent('p'));
   //     $(this).addClass('hide');
           
      //   $('.woocommerce-product-details__short-description p')[0].normalize();
    });
              $('#team-2 .team-content').each(function(){
if ($(this).text.length > 0) {
        myStr2 = $(this).html();
        if($.trim(myStr2).length > maxLength){
            var newStr2 = myStr2.substring(0, maxLength);
            var removedStr2 = myStr2.substring(maxLength, $.trim(myStr2).length);
            $(this).empty().html(newStr2 +' <a href="javascript:void(0);" class="read-more">...read more</a>' );
          //  $(this).append(' <a href="javascript:void(0);" class="read-more">...Read More</a>');
            $(this).append('<span class="more-text">' + removedStr2 + '</span>');
        }
}
    });
    $('#team-2 .read-more').click(function(){
    //    $(this).siblings('.more-text').contents().unwrap();
 $('#team-2 .team-content').replaceWith(myStr2);
  // $('.woocommerce-product-details__short-description p')[0].normalize();
 
// $.trim($(this).parent('p'));
   //     $(this).addClass('hide');
           
      //   $('.woocommerce-product-details__short-description p')[0].normalize();
    });
          
          $('#team-3 .team-content').each(function(){
if ($(this).text.length > 0) {
        myStr3 = $(this).html();
        if($.trim(myStr3).length > maxLength){
            var newStr3 = myStr3.substring(0, maxLength);
            var removedStr3 = myStr3.substring(maxLength, $.trim(myStr3).length);
            $(this).empty().html(newStr3 +' <a href="javascript:void(0);" class="read-more">...read more</a>' );
          //  $(this).append(' <a href="javascript:void(0);" class="read-more">...Read More</a>');
            $(this).append('<span class="more-text">' + removedStr3 + '</span>');
        }
}
    });
    $('#team-3 .read-more').click(function(){
    //    $(this).siblings('.more-text').contents().unwrap();
 $('#team-3 .team-content').replaceWith(myStr3);
      
         });
         $('#team-4 .team-content').each(function(){
if ($(this).text.length > 0) {
        myStr4 = $(this).html();
        if($.trim(myStr4).length > maxLength){
            var newStr4 = myStr4.substring(0, maxLength);
            var removedStr4 = myStr4.substring(maxLength, $.trim(myStr4).length);
            $(this).empty().html(newStr4 +' <a href="javascript:void(0);" class="read-more">...read more</a>' );
          //  $(this).append(' <a href="javascript:void(0);" class="read-more">...Read More</a>');
            $(this).append('<span class="more-text">' + removedStr4 + '</span>');
        }
}
    });
    $('#team-4 .read-more').click(function(){
    //    $(this).siblings('.more-text').contents().unwrap();
 $('#team-4 .team-content').replaceWith(myStr4);
         });
         $('#team-5 .team-content').each(function(){
if ($(this).text.length > 0) {
        myStr5 = $(this).html();
        if($.trim(myStr5).length > maxLength){
            var newStr5 = myStr5.substring(0, maxLength);
            var removedStr5 = myStr5.substring(maxLength, $.trim(myStr5).length);
            $(this).empty().html(newStr5 +' <a href="javascript:void(0);" class="read-more">...read more</a>' );
          //  $(this).append(' <a href="javascript:void(0);" class="read-more">...Read More</a>');
            $(this).append('<span class="more-text">' + removedStr5 + '</span>');
        }
}
    });
    $('#team-5 .read-more').click(function(){
    //    $(this).siblings('.more-text').contents().unwrap();
 $('#team-5 .team-content').replaceWith(myStr5);
         });
      
         $('#team-6 .team-content').each(function(){
if ($(this).text.length > 0) {
        myStr6 = $(this).html();
        if($.trim(myStr6).length > maxLength){
            var newStr6 = myStr6.substring(0, maxLength);
            var removedStr6 = myStr6.substring(maxLength, $.trim(myStr6).length);
            $(this).empty().html(newStr6 +' <a href="javascript:void(0);" class="read-more">...read more</a>' );
          //  $(this).append(' <a href="javascript:void(0);" class="read-more">...Read More</a>');
            $(this).append('<span class="more-text">' + removedStr6 + '</span>');
        }
}
    });
    $('#team-6 .read-more').click(function(){
    //    $(this).siblings('.more-text').contents().unwrap();
 $('#team-6 .team-content').replaceWith(myStr6);
  // $('.woocommerce-product-details__short-description p')[0].normalize();
    });

    }
        
}); 
    
    // end team mobile read more
    
    
    
    
    // service open items on scroll
    
    $( document ).ready(function() {
      
        $('.service').on('click', function() {
      // console.log($(this).attr('id'));
          
     var service = $(this).find('.plus');
      //    console.log(service);
       //   
if(service.hasClass('hide')) {
  //console.log('has');
  
          service.removeClass('hide');
}
          else {
           //  console.log('has not');
            $('.service .plus').removeClass('hide');
              service.addClass('hide');
          }
        });
      
      
    });
    
      // end service open items on scroll
    
    // three images
    
           const tshuffle = gsap.timeline(); 
  
 var shuffle = 1;

       $( document ).ready(function() {
         
          $('.grid').each(function() {
      
         //  var s = $(this);
            
            // could change below .to's to .set's if don't want load in animation
            
            
         tshuffle.to($('#box-1').find('.hidden'), .1, {
                yPercent: -100,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-2').find('.hidden'), .1, {
                xPercent: 100,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-3').find('.hidden'), .1, {
                xPercent: -100,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-1').find('.hidden img'
 ), .1, {
                yPercent: 80,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-2').find('.hidden img'
 ), .1, {
                xPercent: -80,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-3').find('.hidden img'
 ), .1, {
                xPercent: 80,
                ease: Power3.easeOut,
 }),
                
         tshuffle.to($('#box-1').find('.old'), .1, {
                yPercent: -100,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-2').find('.old'), .1, {
                xPercent: 100,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-3').find('.old'), .1, {
                xPercent: -100,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-1').find('.old img'), .1, {
                yPercent: 80,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-2').find('.old img'), .1, {
                xPercent: -80,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-3').find('.old img'), .1, {
                xPercent: 80,
                ease: Power3.easeOut,
 }),
       tshuffle.to($('#box-1').find('.visible'), .1, {
                yPercent: 0,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-2').find('.visible'), .1, {
                xPercent: 0,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-3').find('.visible'), .1, {
                xPercent: 0,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-1').find('.visible img'), .1, {
                yPercent: 0,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-2').find('.visible img'), .1, {
                xPercent: 0,
                ease: Power3.easeOut,
 }),
            tshuffle.to($('#box-3').find('.visible img'), .1, {
                xPercent: 0,
                ease: Power3.easeOut,
             //   onComplete: i
            })
           })
       });
  
    
    
    
       $('.grid').on('click', function() {
   //  console.log('meclick');
         tshuffle.to($('.cursor .icon'), 1, {
                rotation: 360,
                ease: Power3.easeOut,
                clearProps: 'all',
            })
   if(shuffle == 1) {
 //      console.log('shuffle');
  //   console.log(shuffle);
     
      tshuffle.set($('#box-1-layer-1'),  {
      zIndex: 0,
           duration: 0,
            })
        tshuffle.set($('#box-2-layer-1'),  {
      zIndex: 0,
    // delay: -40,
             duration: 0,
            })
      
      tshuffle.set($('#box-3-layer-1'),  {
      zIndex: 0,
   // delay: -20,
           duration: 0,
            })
     
      tshuffle.set($('#box-1-layer-3'),  {
      zIndex: -1,
      duration: 0,
            })
       tshuffle.set($('#box-2-layer-3'),  {
      zIndex: -1,
      duration: 0,
            })
         tshuffle.set($('#box-3-layer-3'),  {
      zIndex: -1,
      duration: 0,
            })
     
    tshuffle.set($('#box-1-layer-2'),  {
                opacity: 0,
      zIndex: 1,
    //  yPercent: 80,
    duration: 0,
            })
        tshuffle.set($('#box-2-layer-2'),  {
                opacity: 0,
      zIndex: 1,
    duration: 0,
            })
     
        tshuffle.set($('#box-3-layer-2'),  {
                opacity: 0,
      zIndex: 1,
    duration: 0,
            })
     
 tshuffle.to($('#box-1-layer-2'),  { 
                yPercent: 0,
                ease: Power3.easeOut,
   duration: 0,
            })
     
     
    tshuffle.to($('#box-2-layer-2'),  { 
                xPercent: 0,
                ease: Power3.easeOut,
         duration: 0,
            })  
     
            tshuffle.set($('#box-3-layer-2'),  {
                zIndex: 0,
                 duration: 0,
            })
     
      
         tshuffle.set($('#box-1-layer-2'),  {
                opacity: 1,
                ease: Power3.easeOut,
              duration: 0,
            })
     
     
       tshuffle.set($('#box-2-layer-2'),  {
                opacity: 1,
                ease: Power3.easeOut,
            duration: 0,
            })
     
     
     
        tshuffle.to($('#box-3-layer-3'),  { 
                xPercent: 0,
                ease: Power3.easeOut,
             duration: 0,
            })
     
      tshuffle.to($('#box-3-layer-2'),  { 
                xPercent: 0,
                ease: Power3.easeOut,
           duration: 0,
        })
     
        tshuffle.set($('#box-3-layer-2'),  {
                opacity: 1,
                ease: Power3.easeOut,
             duration: 0,
            })
    tshuffle.to($('#box-3-layer-2 img'),  { 
                xPercent: 0,
                ease: Power3.easeOut,
                duration: 1,
            })
     
      tshuffle.to($('#box-1-layer-2 img'),  { 
                yPercent: 0,
                ease: Power3.easeOut,
                duration: 1,
       delay: -1,
            })
     
       tshuffle.to($('#box-2-layer-2 img'),  { 
                xPercent: 0,
                ease: Power3.easeOut,
                duration: 1,
       delay: -1,
            })
    

      $('#box-1-layer-1').removeClass('visible')
    $('#box-1-layer-1').removeClass('old')
       $('#box-1-layer-1').addClass('hidden')
  $('#box-1-layer-2').addClass('visible')
       $('#box-1-layer-2').removeClass('hidden')
          $('#box-1-layer-2').removeClass('old')
    $('#box-1-layer-3').removeClass('hidden')
       $('#box-1-layer-3').addClass('old')

      $('#box-2-layer-1').removeClass('visible')
    $('#box-2-layer-1').removeClass('old')
       $('#box-2-layer-1').addClass('hidden')
  $('#box-2-layer-2').addClass('visible')
       $('#box-2-layer-2').removeClass('hidden')
          $('#box-2-layer-2').removeClass('old')
    $('#box-2-layer-3').removeClass('hidden')
       $('#box-2-layer-3').addClass('old')
  
  
 

    
      $('#box-3-layer-1').removeClass('visible')
    $('#box-3-layer-1').removeClass('old')
       $('#box-3-layer-1').addClass('hidden')
  $('#box-3-layer-2').addClass('visible')
       $('#box-3-layer-2').removeClass('hidden')
          $('#box-3-layer-2').removeClass('old')
    $('#box-3-layer-3').removeClass('hidden')
       $('#box-3-layer-3').addClass('old')
     shuffle = 2;
     //  console.log(shuffle);
   }
         
  else if(shuffle == 2) {
            
            tshuffle.set($('#box-1-layer-2'),  {
                zIndex: 0,
              duration: 0,
            })
   
    
 tshuffle.to($('#box-1-layer-3'),  {
                yPercent: 0,
                ease: Power3.easeOut,
       duration: 0,
            })
    
      tshuffle.set($('#box-1-layer-3'),  {
             yPercent: 100,
            duration: 0,
            })
     tshuffle.set($('#box-1-layer-3'),  {
                zIndex: 0,
           duration: 0,
            })
    tshuffle.set($('#box-1-layer-3'),  {
                opacity: 1,
                ease: Power3.easeOut,
                duration: 0,
            })
     tshuffle.to($('#box-1-layer-3'),  { 
                yPercent: 0,
                ease: Power3.easeOut,
                                        duration: 0,
            })
        tshuffle.to($('#box-1-layer-3 img'),  {
      duration: 0,
                yPercent: 80,
                ease: Power3.easeOut,
            })
  
  
           
             tshuffle.set($('#box-2-layer-2'),  {
                zIndex: 0,
                   duration: 0,
            })
   
    
 tshuffle.to($('#box-2-layer-3'),  { 
                xPercent: 0,
                ease: Power3.easeOut,
        duration: 0,
            })
    
      tshuffle.set($('#box-2-layer-3'),  {
             xPercent: -100,
            duration: 0,
            })
     tshuffle.set($('#box-2-layer-3'),  {
                zIndex: 0,
           duration: 0,
            })
    tshuffle.set($('#box-2-layer-3'),  {
                opacity: 1,
                ease: Power3.easeOut,
                duration: 0,
            })
     tshuffle.to($('#box-2-layer-3'),  { 
                xPercent: 0,
                ease: Power3.easeOut,
             duration: 0,
            })
        tshuffle.set($('#box-2-layer-3 img'),  { 
      duration: 0,
      delay: 0,
                xPercent: -80,
                ease: Power3.easeOut,
            })
    
    
    
    
      tshuffle.set($('#box-3-layer-3'),  {
             xPercent: 100,
            duration: 0,
            })
     tshuffle.set($('#box-3-layer-3'),  {
                zIndex: 0,
           duration: 0,
            })
    tshuffle.set($('#box-3-layer-3'),  {
                opacity: 1,
                ease: Power3.easeOut,
          duration: 0,
            
            })
     tshuffle.to($('#box-3-layer-3'),  { 
                xPercent: 0,
                ease: Power3.easeOut,
                duration: 0,
            })
    tshuffle.to($('#box-3-layer-3 img'),  { 
      duration:0,
                xPercent: 80,
                ease: Power3.easeOut,
      delay: 0,
            })
    
      tshuffle.to($('#box-1-layer-3 img'),  {
      duration: 1,
                yPercent: 0,
                ease: Power3.easeOut,
            })
    tshuffle.to($('#box-2-layer-3 img'),  { 
      duration: 1,
      delay: -1,
                xPercent: 0,
                ease: Power3.easeOut,
            })
    tshuffle.to($('#box-3-layer-3 img'),  { 
      duration: 1,
                xPercent: 0,
                ease: Power3.easeOut,
      delay: -1,
            })
    
         $('#box-1-layer-2').removeClass('visible')
    $('#box-1-layer-2').removeClass('old')
       $('#box-1-layer-2').addClass('hidden')
  $('#box-1-layer-3').addClass('visible')
       $('#box-1-layer-3').removeClass('hidden')
          $('#box-1-layer-3').removeClass('old')
    $('#box-1-layer-1').removeClass('hidden')
       $('#box-1-layer-1').addClass('old')
     tshuffle.set($('#box-1-layer-3'),  {
                zIndex: 0,
           duration: 0,
            })
    
       $('#box-2-layer-2').removeClass('visible')
    $('#box-2-layer-2').removeClass('old')
       $('#box-2-layer-2').addClass('hidden')
  $('#box-2-layer-3').addClass('visible')
       $('#box-2-layer-3').removeClass('hidden')
          $('#box-2-layer-3').removeClass('old')
    $('#box-2-layer-1').removeClass('hidden')
       $('#box-2-layer-1').addClass('old')
     tshuffle.set($('#box-2-layer-3'),  {
                zIndex: 0,
            })
           
       $('#box-3-layer-2').removeClass('visible')
    $('#box-3-layer-2').removeClass('old')
       $('#box-3-layer-2').addClass('hidden')
  $('#box-3-layer-3').addClass('visible')
       $('#box-3-layer-3').removeClass('hidden')
          $('#box-3-layer-3').removeClass('old')
    $('#box-3-layer-1').removeClass('hidden')
       $('#box-3-layer-1').addClass('old')
     tshuffle.set($('#box-3-layer-3'),  {
                zIndex: 0,
       duration: 1,
            })
           
           
           
              shuffle = 3;
      // console.log(shuffle);
          }
         
         
         
         
       else if(shuffle == 3) {
         
          tshuffle.to($('#box-1-layer-2'),  { duration: 0,
                yPercent: -100,
                ease: Power3.easeOut,
 })
       
  
        tshuffle.to($('#box-1-layer-2 img'),  { duration: 0,
                yPercent: 80,
                ease: Power3.easeOut,
 })
   
  
     
         tshuffle.to($('#box-1-layer-1'),  { duration: 0,
                yPercent: -100,
                ease: Power3.easeOut,
 })
         
      

          
       tshuffle.to($('#box-1-layer-3'),  { duration: 0,
                yPercent: 0,
                ease: Power3.easeOut,
 })
       
         
          tshuffle.set($('#box-1-layer-3'),  { 
                zIndex: 0,
            duration: 0,
            })
    tshuffle.set($('#box-1-layer-1'),  {
                opacity: 0,
                zIndex: 1,
      duration: 0,
            })
 tshuffle.to($('#box-1-layer-1'),  { 
                yPercent: 0,
                ease: Power3.easeOut,
                                    duration: 0,
            })
    tshuffle.set($('#box-1-layer-1'),  {
                opacity: 1,
                ease: Power3.easeOut,
            duration: 0,
            })
   
    tshuffle.to($('#box-1-layer-1 img'),  { 
      duration: 0,
                yPercent: 0,
                ease: Power3.easeOut,          
            })
                     tshuffle.to($('#box-1-layer-1 img'),  { duration: 0,
                yPercent: 80,
                ease: Power3.easeOut,
                                              
 })
               
          
     
      
                 $('#box-1-layer-3').removeClass('visible')
          $('#box-1-layer-3').removeClass('old')
        $('#box-1-layer-3').addClass('hidden')
         $('#box-1-layer-1').removeClass('hidden')
            $('#box-1-layer-1').removeClass('old')
  $('#box-1-layer-1').addClass('visible')
     
        $('#box-1-layer-2').addClass('old')
        $('#box-1-layer-2').removeClass('hidden')      

    
        tshuffle.to($('#box-2-layer-2'),  { 
          duration: 0,
                xPercent: 100,
                ease: Power3.easeOut,
            })
       
  
        tshuffle.to($('#box-2-layer-2 img'),  { 
          duration: 0,
                xPercent: -80,
                ease: Power3.easeOut,
 })
   
  
     
         tshuffle.to($('#box-2-layer-1'),  { 
          duration: 0,
                xPercent: 100,
                ease: Power3.easeOut,
 })
         
      
  
          
       tshuffle.to($('#box-2-layer-3'),  { duration: 0,
                xPercent: 0,
                ease: Power3.easeOut,
 })
       
                 
            tshuffle.to($('#box-2-layer-3 img'),  { duration: 0,
                xPercent: 0,
                ease: Power3.easeOut,
                                                   delay: 0,
 })
          tshuffle.set($('#box-2-layer-3'),  {
            duration: 0,
                zIndex: 0,
            })
    tshuffle.set($('#box-2-layer-1'),  {
      duration: 0,
                opacity: 0,
                zIndex: 1,
            })
 tshuffle.to($('#box-2-layer-1'),  { 
   duration: 0,
                xPercent: 0,
                ease: Power3.easeOut,
            })
    tshuffle.set($('#box-2-layer-1'),  {
      duration: 0,
                opacity: 1,
                ease: Power3.easeOut,
            
            })
                   tshuffle.to($('#box-2-layer-1 img'),  { 
          duration: 0,
                xPercent: -80,
                ease: Power3.easeOut,
          delay: 0,
 })
   
         
      
                 $('#box-2-layer-3').removeClass('visible')
          $('#box-2-layer-3').removeClass('old')
        $('#box-2-layer-3').addClass('hidden')
         $('#box-2-layer-1').removeClass('hidden')
            $('#box-2-layer-1').removeClass('old')
  $('#box-2-layer-1').addClass('visible')
     
        $('#box-2-layer-2').addClass('old')
        $('#box-2-layer-2').removeClass('hidden')      

      

        tshuffle.to($('#box-3-layer-2'),  { duration: 0,
                xPercent: -100,
                ease: Power3.easeOut,
            })
       
  
        tshuffle.to($('#box-3-layer-2 img'),  { duration: 0,
                xPercent: 80,
                ease: Power3.easeOut,
 })
   
  
     
         tshuffle.to($('#box-3-layer-1'),  { duration: 0,
                xPercent: -100,
                ease: Power3.easeOut,
 })
         
      
        
          
       tshuffle.to($('#box-3-layer-3'),  { duration: 0,
                xPercent: 0,
                ease: Power3.easeOut,
 })
                   
       
 
          tshuffle.set($('#box-3-layer-3'),  {
                zIndex: 0,
            duration: 0,
            })
    tshuffle.set($('#box-3-layer-1'),  {
                opacity: 0,
                zIndex: 1,
        duration: 0,
            })
             tshuffle.set($('#box-3-layer-1'),  {
                opacity: 1,
                ease: Power3.easeOut,
      duration: 0,
       
            })
 tshuffle.to($('#box-3-layer-1'),  { duration: 0,
                xPercent: 0,
                ease: Power3.easeOut,
                              
            })

         
                    tshuffle.to($('#box-3-layer-1 img'),  { duration: 0,
                xPercent: 80,
                ease: Power3.easeOut,
                  delay: 0,                                
 })
     tshuffle.to($('#box-1-layer-1 img'),  { duration: 1,
                yPercent: 0,
                ease: Power3.easeOut,
                                                        
 })
    tshuffle.to($('#box-2-layer-1 img'),  { 
                     duration: 1,
                xPercent: 0,
                ease: Power3.easeOut,
      delay: -1,
            })
     
    tshuffle.to($('#box-3-layer-1 img'),  { duration: 1,
                xPercent: 0,
                ease: Power3.easeOut,
                delay: -1,
            })
     
      
                 $('#box-3-layer-3').removeClass('visible')
          $('#box-3-layer-3').removeClass('old')
        $('#box-3-layer-3').addClass('hidden')
         $('#box-3-layer-1').removeClass('hidden')
            $('#box-3-layer-1').removeClass('old')
  $('#box-3-layer-1').addClass('visible')
     
        $('#box-3-layer-2').addClass('old')
        $('#box-3-layer-2').removeClass('hidden')      

         
           shuffle = 1;
     //  console.log(shuffle);
       }

   });
    
    // end three images
      
/*   $('.grid').on('click', function() {
     console.log('meclick');
         tshuffle.to($('.cursor .icon'), 1, {
                rotation: 360,
                ease: Power3.easeOut,
                clearProps: 'all',
            })
    if($('#box-1-layer-3').hasClass('visible')) {  
  
      
       

       
 }
     
 else if($('#box-1-layer-2').hasClass('visible')) {    
    
     
 }
          
 else if($('#box-1-layer-1').hasClass('visible')) {
      
}
     
     
// box 2     
     
         if($('#box-2-layer-3').hasClass('visible')) {  
  
      
       

 }
     
 else if($('#box-2-layer-2').hasClass('visible')) {    
    
    
 }
          
 else if($('#box-2-layer-1').hasClass('visible')) {
      
}
     // box 3
     
     if($('#box-3-layer-3').hasClass('visible')) {  
  
      
     
    
 }
     
 else if($('#box-3-layer-2').hasClass('visible')) {    
    
     
 }
          
 else if($('#box-3-layer-1').hasClass('visible')) {
      
   
}

   });
    
    // end three images*/
    
        // text-scroll - any text with class, one for each element
        $( document ).ready(function() {
           gsap.registerPlugin(ScrollTrigger);
    gsap.utils.toArray('.textscroll h1').forEach(textscroll => {
      
      
gsap.from(textscroll, {
    scrollTrigger: {
      trigger: textscroll,
       toggleActions: 'play none none none',
      start: 'top 90%',
 //    markers: true,
      end: 'center center',
    toggleClass: 'active',
      scrub: true,
      once: true,
    },
  y: 100, 
    ease: 'power1.out',
  });
screen
});   
    
    
        gsap.utils.toArray('.textscroll p').forEach(textscroll => {
      
      
gsap.from(textscroll, {
    scrollTrigger: {
      trigger: textscroll,
    toggleActions: 'play none none none',
      start: 'top 90%',
 //    markers: true,
      end: 'center center',
    toggleClass: 'active',
      scrub: true,
      once: true,
    },
  y: 100, 
    ease: 'power1.out',
  });
screen
});   
    
           gsap.utils.toArray('.featured-text .textscroll a').forEach(textscroll => {
      
      
gsap.from(textscroll, {
    scrollTrigger: {
      trigger: textscroll,
   toggleActions: 'play reverse play reset',
      start: 'top 90%',
 //    markers: true,
   end: 'top 30%',
    toggleClass: 'active',
      scrub: true,
    //  once: true,
    },
  y: 100, 
    ease: 'power1.out',
  });
screen
});   
          
          
        gsap.utils.toArray('.textscroll h2').forEach(textscroll => {
      
      
gsap.from(textscroll, {
    scrollTrigger: {
      trigger: textscroll,
   toggleActions: 'play none none none',
      start: 'top 90%',
 //    markers: true,
      end: 'center center',
    toggleClass: 'active',
      scrub: true,
      once: true,
    },
  y: 100, 
    ease: 'power1.out',
  });
screen
});   
        gsap.utils.toArray('.textscroll h3').forEach(textscroll => {
      
      
gsap.from(textscroll, {
    scrollTrigger: {
      trigger: textscroll,
  toggleActions: 'play none none none',
      start: 'top 90%',
 //    markers: true,
      end: 'center center',
    toggleClass: 'active',
      scrub: true,
      once: true,
    },
  y: 100, 
    ease: 'power1.out',
  });
screen
});   
    
        gsap.utils.toArray('.textscroll h4').forEach(textscroll => {
      
      
gsap.from(textscroll, {
    scrollTrigger: {
      trigger: textscroll,
      toggleActions: 'play none none none',
      start: 'top 100%',
 //    markers: true,
      end: 'center center',
    toggleClass: 'active',
      scrub: true,
      once: true,
    },
  y: 100, 
    ease: 'power1.out',
  });
screen
});   
        gsap.utils.toArray('.textscroll h5').forEach(textscroll => {
      
      
gsap.from(textscroll, {
    scrollTrigger: {
      trigger: textscroll,
     toggleActions: 'play none none none',
      start: 'top 90%',
 //    markers: true,
      end: 'center center',
    toggleClass: 'active',
      scrub: true,
      once: true,
    },
  y: 100, 
    ease: 'power1.out',
  });
screen
});   
        gsap.utils.toArray('.textscroll blockquote').forEach(textscroll => {
      
      
gsap.from(textscroll, {
    scrollTrigger: {
      trigger: textscroll,
      toggleActions: 'play none none none',
      start: 'top 90%',
 //    markers: true,
      end: 'center center',
    toggleClass: 'active',
      scrub: true,
      once: true,
    },
  y: 100, 
    ease: 'power1.out',
  });
screen
     // end text-scroll - any text with class, one for each element
});
  }); 
    
    $( document ).ready(function() {
       
   //var w =  $( window ).width();
       
    
    gsap.to('progress', {
  value: 100,
  ease: 'none',
  scrollTrigger: {trigger: 'body', start: '100px top', end: 'bottom bottom', scrub: 0.3, id: '1' },
});
       
    });
    
    // full overlay windows 
    
    $('.open-modal-full a').on('click', function() {
  //    console.log('clicked');
      event.preventDefault();
      $('.overlay-window-full').removeAttr('style');
          $('.overlay-window-full').addClass('open');
      $('.overlay-bg-full').fadeIn();
    
      $('.overlay-window-full .ajax-loader-full').fadeIn();
      var pageToLoad = $(this).attr('href');
  //    console.log(pageToLoad);
      
      $.ajax({
        url: pageToLoad,
        success: function(data) {
    //      console.log(data);
          var pagecontent = $(data).find('.main');
    //      console.log(pagecontent);
          $('.overlay-window-full .ajax-loader-full').fadeOut();
    
        
          $('#load-content-full').html(pagecontent).fadeIn('slow', function() { 
            //Done! 
          });
        },
      });
    });
    
    $(document).on('click', '.close-full, .overlay-bg-full', function(){
    $('.overlay-bg-full').fadeOut('fast');
      $('.overlay-window-full').removeClass('open');
      $('.overlay-window-full').fadeOut('fast', function() {
        $('#load-content-full').empty();
      });
    });
    
// end overlay windows full
     // masonry
    //load script images loaded
    /*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */


    // end load script images loaded
    
    
 /**
 * Set appropriate spanning to any masonry item
 *
 * Get different properties we already set for the masonry, calculate 
 * height or spanning for any cell of the masonry grid based on its 
 * content-wrapper's height, the (row) gap of the grid, and the size 
 * of the implicit row tracks.
 *
 * @param item Object A brick/tile/cell inside the masonry
 * @link https://w3bits.com/css-grid-masonry/
 */
function resizeMasonryItem(item){
  /* Get the grid object, its row-gap, and the size of its implicit rows */
  var grid = document.getElementsByClassName('masonry')[0];
  if( grid ) {
    var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
        rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows')),
        gridImagesAsContent = item.querySelector('img.masonry-content');

    /*
     * Spanning for any brick = S
     * Grid's row-gap = G
     * Size of grid's implicitly create row-track = R
     * Height of item content = H
     * Net height of the item = H1 = H + G
     * Net height of the implicit row-track = T = G + R
     * S = H1 / T
     */
    var rowSpan = Math.ceil((item.querySelector('.masonry-content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));

    /* Set the spanning as calculated above (S) */
    item.style.gridRowEnd = 'span '+rowSpan;
    if(gridImagesAsContent) {
      item.querySelector('img.masonry-content').style.height = item.getBoundingClientRect().height + 'px';
    }
  }
}

/**
 * Apply spanning to all the masonry items
 *
 * Loop through all the items and apply the spanning to them using 
 * `resizeMasonryItem()` function.
 *
 * @uses resizeMasonryItem
 * @link https://w3bits.com/css-grid-masonry/
 */
function resizeAllMasonryItems(){
  // Get all item class objects in one list
  var allItems = document.querySelectorAll('.masonry-item');

  /*
   * Loop through the above list and execute the spanning function to
   * each list-item (i.e. each masonry item)
   */
  if( allItems ) {
    for(var i=0;i>allItems.length;i++){
      resizeMasonryItem(allItems[i]);
    }
  }
}

/**
 * Resize the items when all the images inside the masonry grid 
 * finish loading. This will ensure that all the content inside our
 * masonry items is visible.
 *
 * @uses ImagesLoaded
 * @uses resizeMasonryItem
 * @link https://w3bits.com/css-grid-masonry/
 */
function waitForImages() {
  //var grid = document.getElementById("masonry");
  var allItems = document.querySelectorAll('.masonry-item');

  if( allItems ) {
    for(var i=0;i<allItems.length;i++){
     ImagesLoaded( allItems[i], function(instance) {
        var item = instance.elements[0];
        resizeMasonryItem(item);
     //   console.log('Waiting for Images');
      } );
    }
    $('.press-stories-content ').addClass('show');
  }
}

/* Resize all the grid items on the load and resize events */
var masonryEvents = ['load', 'resize'];
masonryEvents.forEach( function(event) {
  window.addEventListener(event, resizeAllMasonryItems);
} );

/* Do a resize once more when all the images finish loading */
waitForImages();  
    // end masonry
    
    // load up masonry content
    if ( $( '.masonry-item' ).length ) {
     let slides = $('.masonry-item');
  var tslides = gsap.timeline();

        tslides.from(slides, {
  marginTop: '75vh',
    ease: 'power1.easeInOut',
  duration: 1.5,
          stagger: .25,
  })

}
    //   .to('.masonry-item span', {duration: .25, delay: -1.5, opacity: 1, stagger: 0})
    //      .to('.masonry-item h4', {duration: .25, delay: -1.5, opacity: 1, stagger: 0});
  
          
    
    // mobile service click

$(document).ready(function() {
 // close service menu
    $('.close-service-menu').on('touchstart', function(event) {
        event.preventDefault();
    $('#main-link-2').removeClass('extra');
    $('#main-link-3').removeClass('extra');
     $('.services-menu-container').css('height', 0);
     $('#main-link-3').css('margin-top', 0);
     $('.mask-container .item').css('margin-top', 0);
     $('.services-menu-container').removeClass('show');
  });
  
  // service menu open
    $('a#main-link-2').on('click touchstart', function(event) {
        event.preventDefault();
       console.log('service menu click');
        // You can add any other custom logic here if needed
        console.log('Touch detected on a link');
      var serviceHeight = $('.services-menu-container-inner').height();
    serviceHeight = serviceHeight + 14;
   if($('.services-menu-container').hasClass('show')) {
          $('#main-link-2').removeClass('extra');
    $('#main-link-3').removeClass('extra');
      $('.services-menu-container').css('height', 0);
     $('#main-link-3').css('margin-top', 0);
     $('.mask-container .item').css('margin-top', 0);
     $('.services-menu-container').removeClass('show');
   }
    else {
        $('#main-link-2').addClass('extra');
    $('#main-link-3').addClass('extra');
       $('.services-menu-container').css('height',serviceHeight);
       $('#main-link-3').css('margin-top',serviceHeight );
       $('.mask-container .item-1').css('margin-top', '-90px');
      $('.mask-container .item-2').css('margin-top', '-150px');
      $('.mask-container .item-lower').css('margin-top', serviceHeight);
      $('.mask-container .item-3').css('margin-top', serviceHeight + 120);
      $('.mask-container .item-4').css('margin-top', serviceHeight + 60);
       $('.services-menu-container').addClass('show');
    }
    });
});
    
    
    
    
    
    
   // end load up masonry content   
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js